import { Component, Inject, OnInit } from "@angular/core"
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog"
import { AnimationItem } from "lottie-web"
import { AnimationOptions } from "ngx-lottie"

@Component({
    selector: "app-autolock-warning-dialog",
    templateUrl: "./autolock-warning-dialog.component.html",
    styleUrls: ["./autolock-warning-dialog.component.scss"],
    standalone: false
})
export class AutolockWarningComponent implements OnInit {
  private anim: AnimationItem
  public lottieConfig: Object
  public signout: string = "Lock"
  options: AnimationOptions = {
    path: "assets/animations/autolock.svg",
    autoplay: true,
    loop: true,
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AutolockWarningComponent>) {}
  ngOnInit(): void {
    this.signout = this.data?.signout ? "Sign out" : "Lock"
  }

  animationCreated(anim: AnimationItem): void {
    this.anim = anim
    this.anim.setSpeed(0.2) // 20sec
  }
}
